export default "__VITE_ASSET__DdGo8cRT__"